import openDialog from '../../utils/dialogs/openDialog';
import DateRangeInput from './DateRangeInput.vue';
export default function open_DateRangeInput_in_GenericDialog(params) {
    const { dateRangeInput_props, genericDialog_props } = params;
    const defaultGenericDialogProps = {
        componentForBodySlotProp: DateRangeInput,
        componentForBodySlotPropsProp: dateRangeInput_props,
        cardProps: {
            hideFooter: true,
            hideHeader: true
        }
    };
    const dialog = openDialog(Object.assign(Object.assign(Object.assign({}, defaultGenericDialogProps), genericDialog_props), { componentForBodySlotProp: DateRangeInput, componentForBodySlotPropsProp: dateRangeInput_props }));
    return dialog;
}
